import React from "react";
import styles from '../../styles/onlineCounselling.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage";
import router from 'next/router';
import useZipmeLink from "../../hooks/useZipmeLink";
import { isFrappeOrJotFormClass } from "../../utils/helpers";
interface Props {
    firstStepEventData: any;
    jotformId: string;
    externalLink: any;
}
const FirstStepWithKC: React.FC<Props> = ({ firstStepEventData, jotformId, externalLink }) => {
    const { zipmeLink, generateLink } = useZipmeLink();
    return (
        <>
            <div className={styles.firstStep} style={{ backgroundColor: firstStepEventData?.sectionBgColor || "#FFF1EF" }}>
                <Container>
                    <Row xl={7} lg={7} md={12} sm={12} className={styles.stuImgtextd}>
                        <div className={styles.heading}>
                            <h2>{firstStepEventData?.sectionTitle}</h2>
                        </div>
                    </Row>
                    <Row >
                        <Col>
                            <div className={styles.headingSec}>
                                <h4>{firstStepEventData?.testTitle}</h4>
                            </div>
                            <div className={styles.para}>
                                <p >{firstStepEventData?.testDescription}</p>
                            </div>
                            <div className={styles.headingSec}>
                                <h4>{firstStepEventData?.offeringsTitle}</h4>
                            </div>

                            <div className={styles.StepContent}>
                                <ul className={styles.ulItem}>
                                    {firstStepEventData?.offeringsPoints?.length > 0
                                        ? firstStepEventData?.offeringsPoints?.length > 0 &&
                                        firstStepEventData?.offeringsPoints?.map((offeringsPoints: any, ind: number) => {
                                            return (
                                                <div key={ind} className={styles.liItem}>
                                                    <CustomImage src={offeringsPoints?.imageUrl || "/images/starthd.png"} width={20} height={20} className={styles.img} alt="EdTech1" />
                                                    <span>{offeringsPoints.title}</span>
                                                </div>
                                            )
                                        })
                                        : firstStepEventData?.offeringsPoints?.length > 0 &&
                                        firstStepEventData?.offeringsPoints?.map((title: string, ind: number) => {
                                            return (
                                                <li key={ind}>{title}</li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                            <div className={styles.anchor}>
                                <a onClick={()=>{
                                    !jotformId && generateLink(externalLink)
                                }} className={`${styles.btnReg} ${ jotformId ? `${isFrappeOrJotFormClass(jotformId)}` : ''}`} >Register Now</a>
                            </div>
                        </Col>
                        <Col xl={5} lg={4} md={12} sm={12} className={styles.stuImgd}>
                            <div className={styles.image} >
                                <CustomImage src={firstStepEventData?.sectionImageUrl || "/images/admissionsday/about-qut.svg"} width={500} height={500} alt="qut.svg" />
                            </div>
                        </Col>
                    </Row>
                </Container >
            </div >
        </>
    )
}
export default FirstStepWithKC;
